// Utilities
import { createSimpleFunctional } from '@/util'

export const VAlertTitle = createSimpleFunctional('v-alert-title')

export type VAlertTitle = InstanceType<typeof VAlertTitle>
